export default "__VITE_ASSET__6c5fb821__"